import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("スタッフ情報の編集")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "mt-1 text-xs text-gray-500" }, " ログインに使うメールアドレスです。変更すると、次回から新しいアドレスでログインし、パスワードの再設定メールも新しいアドレスに届きます。 ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { class: "leading-7 text-sm font-medium text-gray-500" }, " メールアドレス ", -1)
const _hoisted_6 = { class: "w-full bg-primary-100 rounded-md border text-base outline-none text-gray-400 py-1 px-3 leading-8 transition-colors duration-300 border-primary-100" }
const _hoisted_7 = {
  key: 0,
  class: "mt-1 text-xs text-gray-500"
}
const _hoisted_8 = { class: "w-full mx-auto mt-2 text-center text-sm text-gray-500" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ※ パスワードは、セキュリティ上表示できません。")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" パスワード未設定、またはお忘れの場合は、該当スタッフの方に、下記のURLからパスワード設定することを依頼してください。")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_14 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_15 = { class: "w-3/4 mx-auto text-center text-sm text-gray-500" }
const _hoisted_16 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_17 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_18 = {
  key: 1,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, [
  /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "スタッフ一括更新の許可")
], -1)
const _hoisted_20 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", {
  for: "allow-bulk-update-tutors",
  class: "pl-2 cursor-pointer"
}, " スタッフの一括更新を許可 ", -1)
const _hoisted_22 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_23 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = {
  key: 0,
  id: "password-login-disabled",
  type: "checkbox",
  name: "password-login-disabled",
  checked: "",
  disabled: "",
  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("label", {
  for: "password-login-disabled",
  class: "pl-2 cursor-pointer"
}, " パスワードログインを無効にする ", -1)
const _hoisted_27 = {
  key: 0,
  class: "mt-2 text-xs text-gray-500"
}
const _hoisted_28 = {
  key: 1,
  class: "mt-2 text-xs text-gray-500"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" スタッフを削除 ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_multi_select_box = _resolveComponent("m-multi-select-box")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "スタッフ名",
          name: "name",
          type: "text",
          placeholder: "スタッフ名を入力",
          value: _ctx.name,
          invalid: !_ctx.validName,
          "invalid-message": "スタッフ名は入力必須です",
          entered: "",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
        }, null, 8, ["value", "invalid"])
      ]),
      _createVNode("div", _hoisted_3, [
        (_ctx.canEditEmail && _ctx.editTutorEmail)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_m_text_field, {
                label: "メールアドレス",
                name: "login-email",
                type: "email",
                placeholder: "メールアドレスを入力",
                value: _ctx.loginEmail,
                invalid: !_ctx.validLoginEmail,
                "invalid-message": "正しいメールアドレスを入力してください",
                entered: "",
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emailInput = $event))
              }, null, 8, ["value", "invalid"]),
              _hoisted_4
            ], 64))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_5,
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.editTutorEmail ? _ctx.editTutorEmail : "読み込み中..."), 1),
              (!_ctx.canEditEmail)
                ? (_openBlock(), _createBlock("p", _hoisted_7, " メールアドレスの変更は、オーナー（または一括更新を許可された管理者）に依頼してください。 "))
                : _createCommentVNode("", true)
            ], 64)),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _createVNode("a", {
            target: "_blank",
            href: _ctx.passwordSettingUrl
          }, _toDisplayString(_ctx.passwordSettingUrl), 9, ["href"])
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_m_select_box, {
          label: "権限",
          name: "authority",
          placeholder: "権限を選択",
          options: _ctx.authorityTexts,
          value: _ctx.authorityText,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.authorityText = $event))
        }, null, 8, ["options", "value"])
      ]),
      (
          _ctx.authority == 'general' ||
            _ctx.authority == 'employee' ||
            _ctx.authority == 'supervisor'
        )
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode(_component_m_multi_select_box, {
              label: "確認権限を持つ教室一覧",
              name: "classrooms",
              placeholder: _ctx.classroomsPlaceholder,
              options: _ctx.classrooms,
              values: _ctx.selectClassrooms,
              "text-key": "data.name",
              "primary-key": "ref.id",
              onChange: _ctx.changeClassroom
            }, null, 8, ["placeholder", "options", "values", "onChange"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_15, _toDisplayString(`※${
            _ctx.isSchool ? "「管理職」「ICT担当者」" : "「オーナー」「管理者」"
          }権限を持つスタッフは全ての教室の確認権限を持ちます`), 1),
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_m_text_field, {
          label: "Googleアカウント",
          name: "gmail",
          placeholder: 
            _ctx.googleAccountEmail === null
              ? `取得中...`
              : `スタッフのGmailを入力してください（任意）`
          ,
          value: _ctx.googleAccountEmail,
          invalid: !_ctx.validGoogleAccountEmail,
          "invalid-message": "メールアドレスが正しくありません",
          entered: "",
          onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.googleAccountEmail = $event))
        }, null, 8, ["placeholder", "value", "invalid"])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_m_text_field, {
          label: "Microsoftアカウント",
          name: "microsoftEmail",
          placeholder: 
            _ctx.microSoftAccountEmail === null
              ? `取得中...`
              : `スタッフのMicrosoftメールを入力してください（任意）`
          ,
          value: _ctx.microSoftAccountEmail,
          invalid: !_ctx.validMicroSoftAccountEmail,
          "invalid-message": "メールアドレスが正しくありません",
          entered: "",
          onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.microSoftAccountEmail = $event))
        }, null, 8, ["placeholder", "value", "invalid"])
      ]),
      (_ctx.isOwner && _ctx.isEditTutorAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _hoisted_19,
            _createVNode("div", _hoisted_20, [
              _withDirectives(_createVNode("input", {
                id: "allow-bulk-update-tutors",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.allowBulkUpdateTutors = $event)),
                type: "checkbox",
                name: "allow-bulk-update-tutors",
                class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
              }, null, 512), [
                [_vModelCheckbox, _ctx.allowBulkUpdateTutors]
              ]),
              _hoisted_21
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            (_ctx.passwordLoginLockedBySchool)
              ? (_openBlock(), _createBlock("input", _hoisted_25))
              : _withDirectives((_openBlock(), _createBlock("input", {
                  key: 1,
                  id: "password-login-disabled",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.passwordLoginDisabled = $event)),
                  type: "checkbox",
                  name: "password-login-disabled",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512)), [
                  [_vModelCheckbox, _ctx.passwordLoginDisabled]
                ]),
            _hoisted_26
          ]),
          (_ctx.passwordLoginLockedBySchool)
            ? (_openBlock(), _createBlock("p", _hoisted_27, _toDisplayString(`このスクールでは${
                _ctx.isSchool ? "「管理職」「ICT担当者」" : "「オーナー」「管理者」"
              }以外のスタッフはパスワードログインが無効です。Google / Microsoft アカウントでのログインのみ利用できます`), 1))
            : (_openBlock(), _createBlock("p", _hoisted_28, " 有効にすると Google / Microsoft アカウントでのログインのみ利用できます "))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "red-400",
        "hover-color": "red-500",
        outline: "",
        class: "mr-4",
        onClick: _ctx.deleteTutor
      }, {
        default: _withCtx(() => [
          _hoisted_29
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.update
      }, {
        default: _withCtx(() => [
          _hoisted_30
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}